if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      window.addEventListener('shopify:section:load', e => {
        this.initSlider(swiperOptions);
      });
    }

    initSlider(swiperOptions) {
      this.slider = new Swiper(this, {
        slidesPerView: 1,
        loop: swiperOptions.loop || false,
        allowTouchMove: false,
        autoplay: swiperOptions.autoplay || false,
      });

      // Only show arrows when there is more than one message
      if (swiperOptions.loop) {
        this.addArrows();
      }
    }

    // Prev / next arrows either side of the message (PE Nation-style bar)
    addArrows() {
      const host = this.parentElement;
      if (!host) return;

      // avoid duplicates if the section is re-initialised in the theme editor
      host.querySelectorAll('.bar__arrow').forEach(el => el.remove());

      const icons = {
        prev: `<svg viewBox='0 0 24 24' width='24' height='24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M20 12H4M10 6l-6 6 6 6'/></svg>`,
        next: `<svg viewBox='0 0 24 24' width='24' height='24' fill='none' stroke='currentColor' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M4 12h16M14 6l6 6-6 6'/></svg>`
      };

      ['prev', 'next'].forEach(dir => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bar__arrow bar__arrow--' + dir;
        btn.setAttribute('aria-label', dir === 'prev' ? 'Previous announcement' : 'Next announcement');
        btn.innerHTML = icons[dir];
        btn.addEventListener('click', () => {
          if (dir === 'prev') {
            this.slider.slidePrev();
          } else {
            this.slider.slideNext();
          }
        });
        host.appendChild(btn);
      });
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}
